import { cn } from "@/lib/utils";

interface Props {
  /** Sizing classes for the rendered ball (defaults to ~36px). */
  className?: string;
  /** Font-size class for the overlaid GO label. */
  labelClassName?: string;
}

/**
 * The supplied fuzzy tennis-ball PNG used as a menu trigger, with a small
 * centered "GO" overlaid in markup. The PNG itself is never modified.
 */
export default function TennisBallMenuIcon({ className = "w-9 h-9", labelClassName = "text-[9px]" }: Props) {
  return (
    <span
      aria-hidden="true"
      className={cn("relative inline-flex items-center justify-center pointer-events-none select-none", className)}
    >
      <img
        src="/icons/tennis-ball-menu.png"
        alt=""
        decoding="async"
        draggable={false}
        className="w-full h-full object-contain"
      />
      <span
        className={cn(
          "absolute inset-0 flex items-center justify-center font-semibold leading-none tracking-wide text-[hsl(var(--ball-label))]",
          labelClassName,
        )}
      >
        GO
      </span>
    </span>
  );
}
